module.exports = __webpack_public_path__ + "static/media/boat-img-24.dee2071c.jpg";